import {Cureus} from '../Cureus';

Cureus.AdvisorTiles = {};

//= require_tree ./AdvisorTiles